export enum ClientDetailsRealEstateTypeEnum {
  FamilyHouse = 'FamilyHouse',
  Utility = 'Utility',
  Rural = 'Rural',
  Grounds = 'Grounds',
  HouseWithGarage = 'HouseWithGarage',
  ApartmentWithGarage = 'ApartmentWithGarage',
  HouseAndGarage = 'HouseAndGarage',
  ApartmentAndGarage = 'ApartmentAndGarage',
  Conversion = 'Conversion',
  NRFResortion = 'NRFResortion',
  NRFRenovation = 'NRFRenovation',
  Apartment = 'Apartment',
  MobileHome = 'MobileHome',
  HouseBoat = 'HouseBoat',
  MveMgeHouse = 'MveMgeHouse',
  WoodenFrame = 'WoodenFrame',
  HomeAndIndustrial = 'HomeAndIndustrial',
  HouseAndShop = 'HouseAndShop',
  Shop = 'Shop',
  Recreational = 'Recreational',
  Farm = 'Farm',
  Garage = 'Garage',
  Office = 'Office',
  Industrial = 'Industrial',
  ApartmentWithParking = 'ApartmentWithParking',
  CooperativePropertyWithoutUmbrella = 'CooperativePropertyWithoutUmbrella',
  CooperativePropertyWithUmbrella = 'CooperativePropertyWithUmbrella',
  DetachedHouse = 'DetachedHouse',
  Hospitality = 'Hospitality',
  Hotel = 'Hotel',
  HouseAndHospitality = 'HouseAndHospitality',
  HouseAndOffice = 'HouseAndOffice',
  InvestmentProperty = 'InvestmentProperty',
  MortgageBackedSecurity = 'MortgageBackedSecurity',
  Other = 'Other',
  Parking = 'Parking',
  ProfitShareHouse = 'ProfitShareHouse',
  MVE_MGE = 'MVE_MGE',
  NRFCollateralRenovation = 'NRFCollateralRenovation',
  OfficeBuilding = 'OfficeBuilding',
  OtherAreas = 'OtherAreas',
  RecreationalOnPark = 'RecreationalOnPark',
  RuralProperties = 'RuralProperties',
  SingleGarageAtAppartment = 'SingleGarageAtAppartment',
  SingleGarageAtHome = 'SingleGarageAtHome',
  UtilityBuilding = 'UtilityBuilding',
}
